import connection from '@/api/connection'

export const getProductlot = async ({ commit }, options) => {
  let url = `/productlot/selectable/typeproduct/${options.typeproductId}/client/${options.clientId}`;

  await connection.get(url)
    .then(res => {
      const productlot = res.data.data;
      commit('setProductlotSelectable', productlot);
    }).catch(err => {
      console.log('error', err);
    });
}

export const productlotById = async ({ commit }, id) => {
  commit('setProductlotIsLoading', true);
  await connection.get(`/productlot/${id}`)
    .then(res => {
      commit('setProductlotDetail', res.data.data);
      commit('setProductlotIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setProductlotIsLoading', false);
    });
}

export const storeProductlot = async ({ commit }, productlot) => {
  commit('setProductlotIsCreating', true);
  await connection.post(`/productlot/create`, productlot)
    .then(res => {
      commit('saveNewProductlot', res.data);
      commit('setProductlotIsCreating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setProductlotIsCreating', false);
    });
}

export const updateProductlot = async ({ commit }, productlot ) => {
  commit('setProductlotIsUpdating', true);
  await connection.put(`/productlot/${productlot.id}/update`, productlot)
    .then(res => {
      commit('saveUpdatedProductlot', res.data);
      commit('setProductlotIsUpdating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setProductlotIsUpdating', false);
    });
}

export const deleteProductlot = async ({ commit }, productlot) => {
  commit('setProductlotIsDeleting', true);
  await connection.delete(`/productlot/${productlot.id}/delete`)
    .then(res => {
      commit('setDeleteProductlot', res.data);
      commit('setProductlotIsDeleting', false);
    }).catch(err => {
      console.log('error', err);
      commit('setProductlotIsDeleting', false);
    });
}

export const findByProductIdLotIdExpirationAt = async ({ commit }, productlot) => {
  commit('setProductlotIsFinding', true);
  await connection.post(`/productlot/findByProductIdLotIdExpirationAt`, productlot)
    .then(res => {
      commit('findProductlot', res.data.data);
      commit('setProductlotIsFinding', false);
    }).catch(err => {
      console.log('error', err);
      commit('setProductlotIsFinding', false);
    });
}

export const getProductlotListByClient = async ({ commit }, clientId) => {
  commit('setProductlotListByClientIsLoading', true);

  let url = `/productlot/selectable/client/${clientId}`;
  await connection.get(url)
    .then(res => {
      commit('setProductlotListByClientSelectable', res.data.data);
      commit('setProductlotListByClientIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setProductlotListByClientIsLoading', false);
    });
}

export const findByProductIdLotIdExpirationAtPresentationUnitIdTotalAmountClientId = async ({ commit }, productlot) => {
  commit('setProductlotIsFinding', true);
  await connection.post(`/productlot/findByProductIdLotIdExpirationAtPresentationUnitIdTotalAmountClientId`, productlot)
    .then(res => {
      commit('findProductlotExist', res.data.data);
      commit('setProductlotIsFinding', false);
    }).catch(err => {
      console.log('error', err);
      commit('setProductlotIsFinding', false);
    });
}